import React from "react";
import { cn } from "@/utils/cn";
import { DropdownMenu } from "@/components/ui/DropdownMenu";
import type { DropdownMenuEntry } from "@/components/ui/DropdownMenu";

export interface MenuItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  loading?: boolean;
  variant?: "default" | "danger";
  disabled?: boolean;
}

interface ContextMenuProps {
  items: MenuItem[];
  className?: string;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({ items, className }) => {
  const dropdownItems: DropdownMenuEntry[] = items.map((item) => ({
    id: item.id,
    label: item.label,
    icon: item.icon,
    onClick: item.onClick,
    loading: item.loading,
    variant: item.variant,
    disabled: item.disabled,
  }));

  return (
    <DropdownMenu
      items={dropdownItems}
      width="w-48"
      className={className}
      menuClassName="rounded-lg py-1"
      trigger={
        <button
          className={cn(
            "p-1.5 rounded-full shadow-xs transition-all hover:shadow-md",
            "bg-white/90 hover:bg-white text-gray-700"
          )}
          title="Actions"
          data-interactive="true"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
            />
          </svg>
        </button>
      }
    />
  );
};
